<template>
  <div class="dialog-add-account__form-item">
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.visibility_settings') }}
    </div>
    <label v-for="platform in platforms" :key="platform.key" class="input__item-checkbox">
      <input
        type="checkbox"
        :checked="value[platform.key]"
        :disabled="disabled"
        @change="handleChange(platform.key, $event.target.checked)"
      />
      <span class="input__item-checkbox__check">
        <img src="@/assets/icons/icon-done.svg" />
      </span>
      <span class="input__item-checkbox__info">
        <span class="input__item-checkbox__title" v-html="$t(platform.i18nKey)"> </span>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'VisibilitySettings',
  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      platforms: [
        {
          key: 'yandex',
          i18nKey: 'business_account_data.show_yandex',
        },
        {
          key: 'yandexbusiness',
          i18nKey: 'business_account_data.show_yandexbusiness',
        },
        {
          key: 'vkads',
          i18nKey: 'business_account_data.show_vk_ad',
        },
        {
          key: 'google',
          i18nKey: 'business_account_data.show_google',
        },
        {
          key: 'telegram',
          i18nKey: 'business_account_data.show_telegram',
        },
        {
          key: 'promopages',
          i18nKey: 'business_account_data.show_promopages',
        },
        {
          key: 'metricapro',
          i18nKey: 'business_account_data.show_metricapro',
        },
        {
          key: 'mediaplatform',
          i18nKey: 'user_data.show_mediaplatform',
        },
        {
          key: 'vkadblogger',
          i18nKey: 'user_data.show_vkadblogger',
        },
        {
          key: 'ozon',
          i18nKey: 'Показать <span>Ozon</span>',
        },
        {
          key: 'avito',
          i18nKey: 'Показать <span>Avito</span>',
        },
        {
          key: 'urbanads',
          i18nKey: 'user_data.show_urbanads',
        },
      ],
    };
  },
  methods: {
    handleChange(key, checked) {
      const updated = { ...this.value };
      this.$set(updated, key, checked);
      this.$emit('input', updated);
    },
  },
};
</script>
